"use strict";
// Moved from Trackly.WebClient/src/services/ApprovalService/types.ts (T012).
// Mirror of Trackly.Workflows.API.Views.ApprovalRequestView (Services/Workflows/API/Views/ApprovalRequestView.cs)
// Keep field names lowerCamelCase matching backend CamelCaseNamingStrategy serialization.
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveApprovalStatus = void 0;
const deriveApprovalStatus = (a) => {
    if (a.isApproved)
        return 'approved';
    if (a.isRejected)
        return 'rejected';
    if (a.isExpired)
        return 'expired';
    return 'pending';
};
exports.deriveApprovalStatus = deriveApprovalStatus;
